import React, { Component, Fragment } from 'react';

import { CloseModal } from 'modules/common/styles/main';
import Icon from './Icon';

import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';

const propTypes = {
  title: PropTypes.string.isRequired,
  trigger: PropTypes.element.isRequired,
  children: PropTypes.node.isRequired,
  size: PropTypes.string,
  backdrop: PropTypes.bool || PropTypes.string,
  ignoreTrans: PropTypes.bool,
  dialogClassName: PropTypes.string,
  showHide: PropTypes.bool.isRequired,
  closeModal: PropTypes.func,
  openModal: PropTypes.func
};

// const childContextTypes = {
//   closeModal: PropTypes.func.isRequired
// };

const contextTypes = {
  __: PropTypes.func
};

class ModalTrigger extends Component {
  constructor(props) {
    super(props);

    // console.log("Modal Trigger", this.props.showHide);
    // this.state = { isOpen: this.props.showHide };

    // this.openModal = this.openModal.bind(this);
    // this.closeModal = this.closeModal.bind(this);
  }

  static childContextTypes = {
    closeModal: PropTypes.func,
  }

  getChildContext() {
    return { closeModal: this.closeModal };
  }

  // openModal() {
  //   this.setState({ isOpen: true });
  // }

  // closeModal() {
  //   this.setState({ isOpen: false });
  // }

  renderHeader = () => {
    const { __ } = this.context;
    if (this.props.hideHeader) {
      return (
        <CloseModal onClick={this.props.closeModal}>
          <Icon icon="times" />
        </CloseModal>
      );
    }

    const { title, ignoreTrans, paddingContent } = this.props;
    return (
      <Modal.Header closeButton>
        <Modal.Title>{ignoreTrans ? title : __(title)}</Modal.Title>
      </Modal.Header>
    );
  };

  render() {
    const {
      title,
      trigger,
      children,
      size,
      backdrop,
      ignoreTrans,
      dialogClassName,
      closeModal,
      openModal
    } = this.props;
    const { __ } = this.context;

    // add onclick event to the trigger component
    const triggerComponent = React.cloneElement(trigger, {
      onClick: () => openModal()
    });

    return (
      <Fragment>
        {triggerComponent}

        <Modal
          dialogClassName={dialogClassName}
          bsSize={size}
          show={this.props.showHide}
          onHide={() => closeModal()}
          backdrop={backdrop}
          className={dialogClassName}
        >
          {this.renderHeader()}
          <Modal.Body>{children}</Modal.Body>
        </Modal>
      </Fragment>
    );
  }
}

ModalTrigger.propTypes = propTypes;
ModalTrigger.contextTypes = contextTypes;
// ModalTrigger.childContextTypes = childContextTypes;

export default ModalTrigger;



// WEBPACK FOOTER //
// ./src/modules/common/components/ModalTrigger.js